// AUTO-GENERATED from client SVG assets. Protected (admin) use only.
// Maps building floor renders to clickable unit polygons.
export const EXPLORER_SVG = {
  "aerial": {
    "image": "/explorer/aerial.jpg",
    "viewBox": "0 0 2193 1234",
    "regions": [
      {
        "target": "TH",
        "label": "townhouses",
        "points": "636.6,817 605.4,811.1 602.6,811.1 589.8,809 566.6,811.5 566.6,808.3 551.8,805.3 544.1,806.1 526.1,805.3 504.2,812 509,814.8 509,829.5 451.4,838.4 451.4,840.1 449.6,840.1 438.1,836.7 434.2,836.7 434,844 420.6,847.1 412.6,850.5 421.2,853.1 413.9,854.9 378.3,845.8 376.4,846 376.4,851.9 295.1,865.1 295.1,864 267.6,868.3 233.8,873.5 226.7,871.1 221,871.8 220.8,855.1 219.5,854.5 161,863.1 161,875.9 138.1,879.6 138.1,878.9 137.2,878.9 137.8,896.3 136.5,896.7 141.5,1062 169.5,1091.5 238.4,1098.9 377.2,1065.1 472.9,1036.2 496,1036.2 529.1,1026.3 530,1018.7 609.1,998.6 609.1,996.6 611.9,996 611.9,979.7 638.8,979.7 636.6,817"
      },
      {
        "target": "C",
        "label": "block-c",
        "points": "1272.7,949 1263.1,949 1263.1,938.5 1245.2,926.6 1243.5,926.6 1243.5,917.5 1263.9,915.8 1263.9,911.2 1262.2,910.1 1262.2,895.8 1243.5,886.3 1243.5,874 1264.3,872.4 1264.3,862.5 1263.7,861.8 1263.7,848 1243.8,837.9 1243.8,823.5 1246.1,823.5 1246.1,818.3 1244.8,818 1244.8,802.4 1240.5,800.7 1240.5,766.9 1241.8,766.9 1241.8,760.8 1224.2,754.6 1190,755.6 1190,745.7 1175.5,740.2 1118.1,742.6 1118.1,746.3 1067.6,747.8 1067.6,741.1 1058,736.6 1012.3,738.3 1012.3,742.2 1011,741.3 994.6,741.8 994.6,742.2 923.9,744.8 923.9,765.6 872.4,767.1 872.4,780.8 833.4,782 833.4,786.4 807.4,787 807.1,786.4 805,786.4 805,787.2 757.7,789.2 746,789.4 746,783.8 760.3,782.5 767,780.1 762.3,777.5 748.6,775.6 746,774.5 745.8,772.1 688.1,774.6 690.4,970.9 691.1,972.2 693.5,972.2 693.5,979.9 701.9,979.6 703.2,1020.1 1008.7,999.5 1008.7,996.8 1003.8,987.8 1003.8,984.3 1028.9,982.4 1039.9,996.9 1233.9,1004.7 1256.6,1002.8 1264.4,1008.8 1277.6,1007.1 1277.6,952.7 1272.7,949"
      },
      {
        "target": "AB",
        "label": "block-a",
        "points": "2123.8,896.9 2123.8,891.9 2121.8,891.9 2121.8,877.9 2097.8,871.9 2097.8,849.9 2101.8,849.9 2101.8,844.9 2099.8,843.9 2099.8,829.9 2075.8,825.9 2075.8,804.9 1988.8,792.9 1988.8,779.9 1945.8,771.9 1930.8,772.9 1909.8,768.9 1878.8,769.9 1878.8,757.9 1839.8,750.9 1812.8,751.9 1812.8,749.9 1793.8,746.9 1790.8,743.9 1775.8,739.9 1768.8,740.9 1749.8,734.9 1732.8,737.9 1737.8,739.9 1748.8,740.9 1749.8,742.9 1711.8,743.9 1710.8,741.9 1699.8,739.9 1667.8,740.7 1667.8,757.4 1637.4,751.3 1585,753.6 1585,754.8 1552.5,756.1 1552.9,729 1530.8,724.9 1509.1,726 1509.1,718.8 1496.3,716.2 1489.8,716.2 1489.8,719.7 1487.5,719.1 1487.5,712.5 1464.1,708 1433.3,708.8 1433.3,714 1417.3,714.4 1417.3,711 1408.8,709.5 1374.6,710.5 1374.6,718.8 1366.3,719.3 1366.3,729.8 1348.4,730.3 1348.4,722 1329.5,717.5 1293.1,718.9 1293.1,723.8 1258.7,725.1 1258.7,737 1257.8,737 1257.8,752.6 1237,753.2 1237,759.1 1241.8,760.8 1241.8,766.9 1240.5,766.9 1240.5,800.7 1244.8,802.4 1244.8,818 1246.1,818.2 1246.1,823.4 1243.5,823.4 1243.5,837.7 1263.7,847.9 1263.7,861.8 1264.3,862.4 1264.3,872.4 1243.3,873.9 1243.5,886.3 1262.1,895.8 1262.1,910.1 1263.7,911 1263.9,915.8 1243.5,917 1243.5,919.6 1325,970.4 1334.9,975.8 1336,977.5 1366.8,1001.1 1368.3,1001.1 1414.5,995.5 1445.9,1014.3 1492.5,1008.7 1514.1,1020.8 1515.4,1028 1551,1030.4 1593.5,1040.3 1630.1,1051.6 1680,1058.5 1778.1,1058.5 1784.6,1057.7 1784.8,1021 1787.4,1021 1821.8,1035.9 1821.8,1041.9 1845.8,1051.9 1932.8,1041.9 1966.8,1041.9 1985.8,1048.9 1996.8,1054.9 2041.8,1064.9 2071.8,1059.9 2071.8,1034.8 2113.8,1028.9 2113.8,1020.6 2119.8,1019.9 2119.8,1016.9 2118.8,1015.9 2118.8,1001.9 2092.8,993.9 2092.8,982.9 2120.8,979.9 2120.8,976 2119.8,975.9 2119.8,960.9 2093.8,953.9 2093.8,941.9 2122.8,937.9 2122.8,933.9 2120.8,933.9 2120.8,919.9 2094.8,912.9 2094.8,898.9 2123.8,896.9"
      }
    ]
  },
  "AB": {
    "viewBox": "0 0 1626 1084",
    "floors": [
      {
        "level": 1,
        "image": "/explorer/ab-l1.jpg",
        "regions": [
          {
            "unit": "B101",
            "points": "378,436 385,457 382,484 522,482 523,471 551,472 562,291 513.8,291 518,243 460,244 458,264 386,265 386,269 368,269 361,323 379,323 376,347 367,347 364,370 397,370 390,425 380,425 378,436"
          },
          {
            "unit": "B102",
            "points": "400,566 544,564 528,796 471,797 464,868 393,869 396,839 340,840 350,858 347,880 282,881 294,803 315,803 325,728 315,728 320,698 356,698 365,631 355,631 357,621 365,621 370,586 370,566 400,566"
          },
          {
            "unit": "B103",
            "points": "562,272.4 616.9,272.4 616.9,265.8 610.8,265.8 613,223 671.4,223 671,242 742,241 742,248 769,247 770,299 741.2,299.3 741,319 749.5,319 749.5,347 721,347 722,394 725.3,394 727,424 726,467 726,481 700.2,481 699,530 682,530 679,498 574,500 575,451 551,451 562,272.4"
          },
          {
            "unit": "B104",
            "points": "541.7,597.8 568.2,597.8 572,544 694.2,542 693,594 694,594 696,612 724.5,612 724,646 722.5,646 723,657 718.5,657 718,714 750,714 750,761.1 740.3,761.1 740,821 772,822 773,899 708,900 708,879 706,861 653,863 652,891 580,894 584,821 525,822 541.7,597.8"
          },
          {
            "unit": "A101",
            "points": "997,288 1002,337 1049.5,337 1071,528 1044.6,528 1045,530 895,532 893,501 894,482 894,473 904,473 900,417 867,417 866,388 874,388 873,368 845,368 843,313 871,313 871,310 942,309 940,289 997,288"
          },
          {
            "unit": "A102",
            "points": "899,615 1080,612.5 1105,845 1048,846 1055,918 984,919 982,889 926,890 928,928 864,929 862,852 894,851 892,777 883,777 882,747 918,746 914,679 905,679 904,669 901,669 899,633 899,615"
          },
          {
            "unit": "A103",
            "points": "1050.3,344.5 1098.4,344.5 1092,294 1149,294 1152,315 1223,313 1226,327 1243,327 1251,370 1233.6,370 1237,395 1246.4,395 1250,420 1217.1,420 1227,476 1236,476 1238,487 1231,507 1239,553 1207,553 1213,537 1098,538 1096,526 1070.8,526.3 1050.3,344.5"
          },
          {
            "unit": "A104",
            "points": "1105,602 1221,601 1223,617 1249.5,617 1255,653 1265.2,653 1267,664 1257,664 1268,730 1304.2,730 1311,766 1300.9,766 1313,833 1332.7,833 1346,905 1282,905 1279,888 1287,873 1235,874 1239,903 1169,904 1160,834 1104,835 1080,614 1106,614 1105,602"
          }
        ]
      },
      {
        "level": 2,
        "image": "/explorer/ab-l2.jpg",
        "regions": [
          {
            "unit": "B201",
            "points": "367,403 375,426 372,453 515,451 516,438 543,438 555,256 507,257 511,207 451,208 449,228 375,229 374,234 357,234 349,289 367,289 365,313 356,313 352,336 386,336 379,392 369,392 367,403"
          },
          {
            "unit": "B202",
            "points": "393,536 537,534 519,769 462,770 454,843 381,844 384,813 329,814 337,832 333,855 267,856 278,777 299,777 312,700 302,700 307,669 343,669 352,601 342,601 344,591 354,591 358,558 357,536 393,536"
          },
          {
            "unit": "B203",
            "points": "558,237.4 613,237 612.9,230.8 606.8,230.8 609,188 667.4,188 667,207 741,206 740.9,211.5 767,212 768,265 740.2,264.7 740,284 748,284 748,313 719,313 719,360 723,360 723,435 692,435 692,465 567,468 571,418 544,418 558,237.4"
          },
          {
            "unit": "B204",
            "points": "534.7,566.8 561.2,566.8 565,513 691,511 690,564 691,565 693,582 722,582 722,616 720,616 720,627 716,627 716,685 748,685 748,733 738,734 738,797 772,796 773,874 705,876 705,853 703,835 648,836 647,867 573,869 576,796 517,797 534.7,566.8"
          },
          {
            "unit": "A201",
            "points": "1002,254 1007,304 1056.5,303 1076,487 1050,487 1051,499 895,501 894,467 895,448 895,439 905,439 902,385 868,385 867,356 875,356 874,335 846,335 844,279 872,279 872,276 944,275 942,255 1002,254"
          },
          {
            "unit": "A202",
            "points": "902,585 1060,583 1060,585 1087,585 1112.9,819.8 1055.9,820.8 1061,894 989,896 987,865 930,865 931,905 866,906 863,827 897,827 894,751 885,751 883,720 921,719 917,651 907,651 907,640 904,640 902,605 902,585"
          },
          {
            "unit": "A203",
            "points": "1057.3,310.5 1105.4,310.5 1099,260 1158,260 1161,281 1233,279 1235,286 1252,286 1261,337 1244.6,337 1248,362 1257.4,362 1262,387 1228.1,387 1238,444 1247,444 1250,455 1242,478 1250,524 1216,524 1222,506 1106,507 1103,492 1077.8,492.3 1057.3,310.5"
          },
          {
            "unit": "A204",
            "points": "1112,572 1232,571 1235,588 1261,588 1267,625 1277,625 1279,635 1269,635 1280,703 1318,703 1325,740 1315,740 1328,809 1348,808 1361,881 1296,882 1293,865 1302,849 1247,849 1253,881 1180,881 1170,808 1112,809 1087,586 1114,586 1112,572"
          }
        ]
      },
      {
        "level": 3,
        "image": "/explorer/ab-l3.jpg",
        "regions": [
          {
            "unit": "B301",
            "points": "355,368 363,391 359,418 507,416 508,404 535,404 548,219 498.8,220 504,170 442,171 440,191.5 364,191.5 364,198 346,198 338,254 356,254 353,276 343,276 339,302 375,301 367,357 357,357 355,368"
          },
          {
            "unit": "B302",
            "points": "376,503 500,501 500,502 529,502 510,741 450,742 443,816 367,818 371,786 312,787 322,806 319,829 251,830 263,750 284,750 296,670 286,670 291,639 330,639 339,570 328,570 330,559 341,559 345,525 338,503 376,503"
          },
          {
            "unit": "B303",
            "points": "550,200 608,200 607.9,192.8 601.8,192.8 604,150 664,149 664,169 738,169 738,175 766,175 766,228 737,228 737,249 746,249 746,277 717,278 716,324 721,324 721,334.6 722,356 721,402 689,402 689,432 561,434 564,384 536,384 550,200"
          },
          {
            "unit": "B304",
            "points": "527.7,532.8 554.2,532.8 558,479 688,477 687,531 688,532 690,550 720,550 720,585 717,585 717,596 713,596 713,655 745,655 746,704 735,704 735,769 770,769 770,850 702,851 702,827 700,808 642,810 641,841 566,842 569,767 508,768 527.7,532.8"
          },
          {
            "unit": "A301",
            "points": "1007,218 1013,269 1062.5,268 1083,454 1056,454 1057,466 899,468 898,440 899,417 899,408 908,408 905,351 870,351 869,322 878,322 877,302 847,302 845,246 874,246 874,241 948,240 946,219 1007,218"
          },
          {
            "unit": "A302",
            "points": "904.1,554 1066.5,552 1066.5,554 1094.3,554 1120.9,793.9 1062.3,795 1067.5,869.7 993.5,871.8 991.5,840.1 932.9,840.1 935,881 867.1,882 864,801.3 899,801.3 895.9,723.6 886.6,723.6 884.6,692 923.6,691 919.5,621.5 909.2,621.5 909.2,610.2 906.1,610.2 904.1,574.5 904.1,554"
          },
          {
            "unit": "A303",
            "points": "1063,276 1113,275 1107,224 1167,224 1170,245 1244,244 1245,252 1263,252 1272,303 1255,303 1260,328 1268,328 1273,353 1238,353 1248.6,411 1258,411 1261,421 1254,442 1262,492 1228,492 1234,473 1113,475 1112,462 1084,462 1063,276"
          },
          {
            "unit": "A304",
            "points": "1120.6,539 1243.7,538 1246.8,555.4 1273.5,555.4 1279.6,593.4 1289.8,593.4 1291.9,603.6 1281.7,603.6 1292.9,673.4 1331.9,673.4 1339.1,711.4 1328.8,711.4 1342.2,782.1 1362.7,781.1 1376,856 1309.3,857 1306.3,839.6 1315.5,823.1 1259.1,823.1 1265.2,856 1190.4,856 1180.1,781.1 1120.6,782.1 1095,553.4 1122.7,553.4 1120.6,539"
          }
        ]
      },
      {
        "level": 4,
        "image": "/explorer/ab-l4.jpg",
        "regions": [
          {
            "unit": "B401",
            "points": "341,330 350,354 346,383 498,381 500,368 528,368 542,181 491,181 495,130 432,131 430,152 353,153 352,160 334,160 325,216 344,216 341,238 330,238 326,264 363,263 355,320 343,320 341,330"
          },
          {
            "unit": "B402",
            "points": "492,466.2 492,467.2 520.2,467.2 500.8,711.1 439.4,712.1 432.3,787.6 352.6,789.7 356.7,757 297.4,759.1 307.6,778.4 304.5,801.9 233,803 246,720 266,720 280,638.7 269.8,638.7 275,607 314,607 325,536 315,536 316.8,525 328,525 332.1,490.7 324.9,468.2 492,466.2"
          },
          {
            "unit": "A401",
            "points": "1012.1,180.4 1018.3,232.5 1069.3,231.4 1090.5,421.2 1062.6,421.2 1063.7,433.5 900.7,435.5 899.7,406.9 900.7,383.5 900,372 911,372 906.9,314 870.8,314 869.8,289 880,289 879,265 848.4,264.9 845.4,208.9 874.9,209 874.9,203.9 951.2,202.9 949.2,181.4 1012.1,180.4"
          },
          {
            "unit": "A403",
            "points": "1070,239.6 1121.2,238.6 1115,186.5 1176.4,186.5 1179.4,208 1255.1,206.9 1256.1,215.1 1274.5,215.1 1283.7,267.1 1266.3,267.1 1271.4,292.7 1279.6,292.7 1284.7,318.2 1248.9,318.2 1259.8,377.4 1269.4,377.4 1272.4,387.6 1265.3,409 1273.5,460 1238.7,460 1244.8,440.6 1121.2,442.7 1120.1,429.4 1091.5,429.4 1070,239.6"
          }
        ]
      },
      {
        "level": 5,
        "image": "/explorer/ab-l5.jpg",
        "regions": [
          {
            "unit": "A402",
            "points": "909,486 1109.6,483 1142,736 1078,737 1086,815 1006,816 1003,785 999,802 894,803 887,649 927,648 930,629 927,576 914,577 910,509 909,486"
          },
          {
            "unit": "A404",
            "points": "1269,471 1272,491 1299,491 1308,539 1310,539 1324,611 1326,611 1318,630 1355,629 1385,783 1292,784 1294,798 1215,800 1205,723 1140,723 1109,474 1269,471"
          },
          {
            "unit": "B403",
            "points": "537,121 590.3,121 593,70 656.1,70 656.1,90.1 735,89 735,95.5 763.7,95.5 764,151 732.8,151 733,171 742.6,171 743,200 712.3,200 713,258 715.5,258 717,281 716,329 700,329 699,380 668.8,380 666,359 517,361 537,121"
          },
          {
            "unit": "B404",
            "points": "666,406 668,425 698,425 697,482 714,482 713,518 708,518 707,590 741,590 741,629 731,629 730,709 768,709 768,794 694,794 695,771 693,751 631,751 630,784 549,786 554,708 489,708 514,409 666,406"
          }
        ]
      }
    ]
  },
  "C": {
    "viewBox": "0 0 1626 1084",
    "floors": [
      {
        "level": 1,
        "image": "/explorer/c-l1.jpg",
        "regions": [
          {
            "unit": "C101",
            "points": "510,686 506,739 442.2,739 444,725 352,727 363,751 359,792 243,794 257,705 269,705 282,611 234.6,611 251,521 255.6,521 275,390 577,389 580,361 773,359 771,446 730,446 729,481 753,481 751,518 747,719 655,720 649,697 628,697 629,684 510,686"
          },
          {
            "unit": "C102",
            "points": "907,517 930,517 929.4,480 1294,477 1303,548 1413.6,548 1427,639 1379.5,639 1392,735 1407.9,735 1420,824 1304.8,824 1299,781 1308,759 1217,759 1219,773 1153,773 1150,720 1031,721 1031,734 1010,734 1007,755 911,758 907,517"
          },
          {
            "unit": "C103",
            "points": "884,282 887,444 910.2,444 910.2,480.4 930,480 1277,477 1268,407 1376,406 1364,325 1321,325 1317,294 1331,294 1321,224 1222,225 1222,231 1143,231 1142,221 1096,221 1099,263 993,264 992,254 975,254 975,262 973,262 963,267 962,281 884,282"
          }
        ]
      },
      {
        "level": 2,
        "image": "/explorer/c-l2.jpg",
        "regions": [
          {
            "unit": "C201",
            "points": "495,645 490.8,699.5 424.6,699.5 426.4,685.1 330.9,687.1 342.4,711.8 338.2,753.9 217.8,756 232.3,664.5 244.8,664.5 258.3,568 209,568 226.1,475.5 296,474 316,340.9 564.5,339.8 567.6,311.1 768,309 765.9,398.4 723.4,398.4 722.3,434.4 747.2,434.4 745.2,472.4 741,678.9 645.5,680 639.3,656.3 617.5,656.3 618.5,643 495,645"
          },
          {
            "unit": "C202",
            "points": "907,471.3 930.9,471.3 930.3,433.1 1309.6,430 1319,503.2 1434.1,503.2 1448,597.1 1398.6,597.1 1411.6,696.2 1428.1,696.2 1440.7,788 1320.9,788 1314.8,743.6 1324.2,720.9 1229.5,720.9 1231.6,735.4 1162.9,735.4 1159.8,680.7 1036,681.7 1036,695.1 1014.2,695.1 1011,716.8 911.2,719.9 907,471.3"
          },
          {
            "unit": "C203",
            "points": "884,230.3 887.1,395.9 911.1,395.9 911.1,433 931.7,432.6 1291.4,429.6 1282,358 1394,357 1381.6,274.3 1337,274.3 1332.8,242.6 1347.3,242.6 1337,171.1 1234.4,172.1 1234.4,178.2 1152.5,178.2 1151.4,168 1103.8,168 1106.9,210.9 997,211.9 996,201.7 978.3,201.7 978.3,209.9 976.3,209.9 965.9,215 964.9,229.3 884,230.3"
          }
        ]
      },
      {
        "level": 3,
        "image": "/explorer/c-l3.jpg",
        "regions": [
          {
            "unit": "C301",
            "points": "478.8,600.3 474.4,656.1 405.2,656.1 407.2,641.4 307.4,643.5 319.3,668.7 315,716 189.2,718.1 204.3,620.3 215,620 231.5,521.3 180,521.3 197,425 271,425 291.8,288.6 551.4,287.6 554.7,258.1 764,256 761.8,347.6 717.4,347.6 716.3,377 742.3,377 740.1,423.4 735.8,635 636,636.1 629.5,611.9 606.7,611.9 607.8,598.2 478.8,600.3"
          }
        ]
      },
      {
        "level": 4,
        "image": "/explorer/c-l4.jpg",
        "regions": [
          {
            "unit": "C302",
            "points": "912,542 1046.1,542 1051,586 1187,583 1191,642 1265.8,642 1265.8,644.3 1256,673 1452,671 1432,532 1452,495.4 1499.9,495.4 1483,395 1358.1,395 1347,317 907.9,321.8 912,542"
          },
          {
            "unit": "C303",
            "points": "884,120 888,322 1327,318 1317,243 1437,241 1422,153 1356,154 1345,83 1113,85 1113,88 1005,88 1007,123 982,123 982,118 884,118 884,120"
          }
        ]
      }
    ]
  },
  "TH": {
    "viewBox": "0 0 2193 1234",
    "image": "/explorer/th.jpg",
    "regions": [
      {
        "unit": "Townhouse 1",
        "points": "1388,877 1385,641 1373,638 1355,642.4 1355,652 1221,605 1221,575 1277,563 1277,555 1219,537 1216.7,350.1 1112.2,323.4 1106.5,324 1106.5,341.2 867.6,380.1 867.6,376.9 786.7,389.6 687.3,404.9 666.3,397.9 649.7,399.8 649.1,350.8 645.3,348.9 473.3,374.4 473.3,411.9 405.8,422.8 405.8,420.9 403.2,420.9 405.1,471.8 401.3,473.1 416,959.1 498.1,1045.7 700.7,1067.4 1109,968 1390.2,883.3 1390.4,883.4 1388,877"
      },
      {
        "unit": "Townhouse 2",
        "points": "1871.5,238.7 1779.8,221.5 1771.5,221.5 1733.9,215.1 1665.7,222.7 1665.7,213.2 1622,204.3 1599.5,206.8 1546.6,204.3 1482.3,224 1496.3,232.3 1496.3,275.6 1326.8,301.7 1326.8,306.8 1321.7,306.8 1288,296.6 1276.5,296.6 1275.9,318.3 1236.4,327.2 1212.8,337.4 1238.3,345.1 1216.6,350.2 1219,537 1277,555 1277,563 1221,575 1221,605 1355,652 1355,642.4 1373,638 1385,641 1388,877 1390.3,883.4 1458,883.3 1555.5,854 1558,831.7 1790.5,772.7 1790.5,766.8 1798.7,764.9 1798.7,717.1 1877.8,717.1 1871.5,238.7"
      }
    ]
  }
};
